import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Wait from "../../../Manager/Checkout/Wait";

import UpdateBillingInfoButton from "./UpdateBillingInfoButton";
import { useContext } from "../Context";

export default function Index() {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.loadBillingInformation(dispatch, state.enterpriseId);
  }, []);

  return (
    <>
      <div className="inviteTabsCheckout_main">
        <div className="inviteTabsCheckoutMain_title">Billing Information</div>
      </div>
      <div className="invite-wrapper inviteTabsCheckout_control">
        {state.billingInformation == null && (
          <div className="mb20">
            <Wait />
          </div>
        )}
        {state.billingInformation != null && (
          <Row>
            <Col md={8}>
              <dl className="dl-horizontal font-14">
                <dt>Name</dt>
                <dd>{state.billingInformation.attributes.name}</dd>
                <dt>E-Mail</dt>
                <dd>{state.billingInformation.attributes.email}</dd>
                <dt>Country</dt>
                <dd>{state.billingInformation.attributes.country}</dd>
                <dt>City</dt>
                <dd>{state.billingInformation.attributes.city}</dd>
                <dt>Address Line 1</dt>
                <dd>{state.billingInformation.attributes.address_line1}</dd>
                <dt>Address Line 2</dt>
                <dd>{state.billingInformation.attributes.address_line2}</dd>
                <dt>Postal Code</dt>
                <dd>{state.billingInformation.attributes.postal_code}</dd>
              </dl>
            </Col>
            <Col md={4} className="text-right">
              <UpdateBillingInfoButton />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}
